import { HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

export const Mobile: React.FC = () => {
  return (
    <VStack width="full" space={Spacing['inline.nano']} px={Spacing['inline.xxxs']}>
      <HStack alignItems="center" justifyContent="space-between" flex={1}>
        <Skeleton
          w="30%"
          h={Typography['fontsize.xl']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
        <Skeleton
          w="25%"
          h={Typography['fontsize.xl']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
      </HStack>
      <Skeleton
        w="50%"
        h={Typography['fontsize.xl']}
        borderRadius={BoxRadius.sm}
        endColor={Color['brand.primary.lightest']}
      />
    </VStack>
  );
};
